import React, { FunctionComponent } from 'react';
import Switch, { SwitchProps } from '@material-ui/core/Switch';
import toggleSwitchStyles from './currencySwitchStyles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Translation from '../translation/Translation';

export interface IToggleSwitchProps {
  /**
   * Label displayed on disabled switch
   */
  labelBefore: string;
  /**
   * Label displayed on active switch
   */
  labelAfter: string;
  disableRipple?: boolean;
}

const ToggleSwitch: FunctionComponent<SwitchProps & IToggleSwitchProps> = ({
  disableRipple,
  labelBefore,
  labelAfter,
  ...props
}) => {
  const styles = toggleSwitchStyles(props);

  return (
    <>
      <Grid component="label" container={true} alignItems="center" spacing={1} className={styles.switchContainer}>
        <Typography component="p" className={styles.selectCurrency}>
          <Translation id={'spc.configuratorSummary.selectCurrency'} defaultMessage="Select currency:" />
        </Typography>
        <Typography
          component="p"
          className={props.checked ? styles.unselectedCurrency : styles.selectedCurrency}
          data-test={`currency_switch:label:before_${!props.checked}`}
        >
          {labelBefore}
        </Typography>
        <Box>
          <Switch
            {...props}
            focusVisibleClassName={styles.focusVisible}
            disableRipple={disableRipple}
            classes={{
              root: styles.root,
              switchBase: styles.switchBase,
              thumb: styles.thumb,
              track: styles.track,
              checked: styles.checked,
            }}
          />
        </Box>
        <Typography
          component="p"
          className={props.checked ? styles.selectedCurrency : styles.unselectedCurrency}
          data-test={`currency_switch:label:after_${props.checked}`}
        >
          {labelAfter}
        </Typography>
      </Grid>
    </>
  );
};

export default ToggleSwitch;
